(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = document.querySelectorAll('#MainContent > .shopify-section');

  if (!sections.length) return;

  sections.forEach(function (section, index) {
    section.classList.add('scroll-reveal');
    section.setAttribute('data-reveal-delay', String(Math.min(index, 4)));
  });

  // Make the first section visible immediately
  var firstSection = sections[0];
  if (firstSection) {
    firstSection.style.transitionDelay = '0s';
    firstSection.classList.add('scroll-reveal--visible');
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  sections.forEach(function (section, index) {
    // Skip first section — already revealed
    if (index === 0) return;
    observer.observe(section);
  });
})();
